export const NAV = [
  { label: "How It Works", to: "/how-it-works" },
  {
    label: "Services",
    children: [
      { label: "Used Cars", to: "/used-cars" },
      { label: "Unwanted Cars", to: "/unwanted-cars" },
      { label: "Scrap Cars", to: "/scrap-cars" },
      { label: "Old Cars", to: "/old-cars" },
      { label: "Junk Cars", to: "/junk-cars" },
      { label: "Car Removals", to: "/car-removals" },
    ],
  },
  { label: "Areas", to: "/areas" },
  { label: "Blog", to: "/blog" },
  { label: "FAQ", to: "/faq" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const SERVICE_SLUGS = ["used-cars", "unwanted-cars", "scrap-cars", "old-cars", "junk-cars", "car-removals"];

// Phase-one priority centres (named schema entries + landing pages).
export const PRIORITY_CENTRES = [
  ["Melbourne CBD", "melbourne-cbd"], ["Dandenong", "dandenong"], ["Frankston", "frankston"], ["Werribee", "werribee"], ["Sunshine", "sunshine"],
  ["Craigieburn", "craigieburn"], ["Broadmeadows", "broadmeadows"], ["Preston", "preston"], ["Footscray", "footscray"], ["Box Hill", "box-hill"],
  ["Ringwood", "ringwood"], ["Glen Waverley", "glen-waverley"], ["Cranbourne", "cranbourne"], ["Berwick", "berwick"], ["Pakenham", "pakenham"],
  ["Melton", "melton"], ["Point Cook", "point-cook"], ["Epping", "epping"], ["Greensborough", "greensborough"], ["Bentleigh", "bentleigh"],
  ["Moorabbin", "moorabbin"], ["Mornington", "mornington"], ["Geelong", "geelong"], ["Ballarat", "ballarat"], ["Bendigo", "bendigo"],
];

export const CAR_BRANDS = [
  "Toyota", "Holden", "Ford", "Mazda", "Hyundai", "Mitsubishi", "Nissan", "Volkswagen",
  "Kia", "Subaru", "Honda", "BMW", "Mercedes-Benz", "Audi", "Suzuki", "Isuzu", "Jeep",
  "Land Rover", "Lexus", "Renault", "Peugeot", "Volvo", "Skoda", "MG", "Great Wall", "LDV", "Other",
];

const CDN = "https://static.prod-images.emergentagent.com/jobs/4e952e75-862c-4d14-b30e-b7cc99cfb553/images";
export const HERO_IMG = `${CDN}/b7fa4a1c93518ce90aeeafdccae6ac650c2e36d5a0ddcf21024ad752ed891d67.jpeg`;
export const CASH_COUNTING_IMG = `${CDN}/434a1aabb754103d9e1f837cb29c13bc00988d0a5d9b549cd45ae242f12c33fe.jpeg`;
export const CASH_FAN_IMG = `${CDN}/a306d9f82a590a3878ca9ccfe7e4097fe242ec03edf87daeed2f4de68468ab9d.jpeg`;
export const OG_IMG = `${CDN}/6e4230fb7be7826a3aded3f39cebf17ff8c18653a6a8140216bd83c2e88f93d9.jpeg`;
export const TOW_IMG = `${CDN}/c7af530fed21e65ce58fc9612afe954b1535a33e51b1e4bae0d735e48a57da09.jpeg`;
export const MELB_IMG = "https://images.unsplash.com/photo-1596527199903-6cdaacee1208?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxtZWxib3VybmUlMjBjaXR5c2NhcGV8ZW58MHx8fHwxNzg2MDkxMzI0fDA&ixlib=rb-4.1.0&q=85";
